import { useContext, useEffect, useState } from 'react';

import ImageGallery from '../../../../../reusable/images/image-gallery/image-gallery.component';
import AddImage from '../../../../../reusable/images/add-image/add-image.component';
import ComponentModal from '../../../../../reusable/component-modal/component-modal.component';
import Spinner from '../../../../../reusable/spinner/spinner.component';
import Button from '../../../../../reusable/button/button.component';

import { ToastContext } from '../../../../../../contexts/toast.context';
import Client from '../../../../../../tools/client';

import {
  Container,
  FieldSection,
  FieldGroup,
  Label,
  TextSmall,
  ButtonRow
} from '../../../configuration-sections.styles';

const client = new Client();

const OgImageConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [configuration, setConfiguration] = useState(null);
  const [ogImage, setOgImage] = useState([]);
  const [image, setImage] = useState(null);
  const [cropData, setCropData] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const { errorToast, successToast } = useContext(ToastContext);
  const configKey = 'site.ogImage';

  useEffect(() => {
    fetchOgImage();
  }, []);

  const fetchOgImage = async () => {
    setLoading(true);
    const res = await client.getConfigurationByKey(configKey);
    if (res?.images) {
      const formattedImages = res.images.map((image) => ({
        ...image,
        path: image.path + '.webp',
      }));
      setOgImage(formattedImages);
    }
    setConfiguration(res);
    setLoading(false);
  };

  const saveOgImage = async (file) => {
    let formData = new FormData();
    formData.append('files', file);
    formData.append('key', configKey);

    const res = await client.addConfigurationImage(formData);
    if (res?.status === 200) {
      successToast('OG image uploaded successfully');
      fetchOgImage();
      setShowAddModal(false);
    } else {
      errorToast('Failed to upload OG image');
    }
  };

  const handleDeleteImage = async (id) => {
    const res = await client.deleteConfigurationEntryImage(configuration.id, id);

    if (res?.status === 200) {
      successToast('OG image deleted');
      fetchOgImage();
    } else {
      errorToast('Failed to delete OG image');
    }

    setSelectedImage(null);
  };

  return (
    <Container>
      <ComponentModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        title="Upload OG Image"
      >
        <AddImage
          image={image}
          setImage={setImage}
          saveImage={saveOgImage}
          showSaveButton={true}
          setCropData={setCropData}
        />
      </ComponentModal>

      <FieldSection>
        <FieldGroup>
          <Label>OG Image</Label>
          <TextSmall>
            This image is used for social sharing previews (Open Graph). It appears when
            someone shares your site on platforms like Facebook, Slack, X (Twitter), or iMessage.
            Only one OG image can be active at a time.
          </TextSmall>
        </FieldGroup>

        {loading ? (
          <Spinner />
        ) : ogImage.length > 0 ? (
          <ImageGallery
            images={ogImage}
            onDelete={handleDeleteImage}
          />
        ) : (
          <FieldGroup>
            <TextSmall>No OG image uploaded yet.</TextSmall>
          </FieldGroup>
        )}

        <ButtonRow>
          <Button onClick={() => setShowAddModal(true)}>
            {ogImage.length === 0 ? 'Add OG Image' : 'Replace OG Image'}
          </Button>
        </ButtonRow>
      </FieldSection>
    </Container>
  );
};

export default OgImageConfigurationDisplay;